import { RESET_PASS_TOKEN } from '../constants/list';

export function storeResetPassToken(resetPassToken) {

  return {
    type: RESET_PASS_TOKEN,
    payload: resetPassToken
  }

}